import { Box } from '@montugroup/design-system';
import MenuIcon from '@mui/icons-material/Menu';
import AppBar from '@mui/material/AppBar';
import { styled } from '@mui/material/styles';
import Toolbar from '@mui/material/Toolbar';

export const StyledNavigationBar = styled(AppBar)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  width: '100%',
  boxShadow: 'none',
}));

export const StyledNavToolbar = styled(Toolbar)(({ theme }) => ({
  padding: theme.spacing(4),
  justifyContent: 'space-between',
  gap: theme.spacing(8),
  [theme.breakpoints.down('md')]: {
    paddingLeft: theme.spacing(5),
  },
}));

export const StyledMenuIconContainer = styled(Box)`
  display: flex;
`;

export const StyledMenuIcon = styled(MenuIcon)(({ theme }) => ({
  height: 35,
  width: 35,
  color: theme.palette.common.white,
}));
